import { SxProps, Theme } from '@mui/material'

export const nestedTabsBoxWrapper = {
  width: '100%',
  minHeight: '100%',
  bgcolor: '#fff',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}

export const tabStyle = {
  bgcolor: '#FFFFFF',
  flex: 1,
  minWidth: 0,
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  fontSize: { xs: 11, sm: 12, md: 14, lg: 16, xl: 16 },
}

export const dataAnalysisFiltersBoxWrapper = {
  marginTop: '1vh',
  width: '100%',
  minHeight: '74vh',
  marginLeft: '1.5vw',
}

export const gridWrapperBox = {
  width: '25vw',
}

export const dividerBoxStyle = {
  height: '1.5vh',
  backgroundColor: '#F9F9F9',
}

export const dataAnalysisContentContainer = {
  padding: '16px',
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  maxHeight: 'calc(100vh - 240px)',
}

export const dividerStyle = {
  bgcolor: 'STROKES',
  width: '1px',
  height: '90%',
  marginTop: '60%',
  marginRight: 0,
  marginLeft: '70%',
}

export const root: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  height: '100%',
  width: '100%',
  overflow: 'hidden',
}

export const sidebar: SxProps<Theme> = {
  maxWidth: '100%',
  minWidth: 0,
  width: '100%',
  height: '100%',
  minHeight: '72vh',
  overflow: 'auto',
  borderRight: { md: '1px solid #e0e0e0' },
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  position: 'static',
  top: 16,
  zIndex: 2,
}

export const content: SxProps<Theme> = {
  flex: { xs: '0 0 auto', md: '2' },
  minWidth: 0,
  height: { xs: 'auto', md: '100%' },
  overflow: 'auto',
  p: 2,
}

export const buttonContainer = {
  position: 'relative',
  marginTop: '8px',
}

export const infoMessageContainer = {
  display: 'flex',
  alignItems: 'center',
  marginTop: '4px',
  marginBottom: '4px',
  marginRight: '24px',
  padding: '4px',
  backgroundColor: (theme) => theme.palette.grey[50],
  borderRadius: '4px',
  position: 'absolute',
  fontSize: '12px',
  top: -16,
}

export const infoIcon: SxProps<Theme> = {
  marginRight: '8px',
  color: (theme) => theme.palette.info.main,
  fontSize: '14px',
}

export const applyButton = {
  height: '32px',
  marginRight: '10px',
  marginTop: '8px',
}

export const trendChartLoadingBoxWrapper = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '72vh',
  width: '60vw',
  mx: 'auto',
  px: 2,
  boxSizing: 'border-box',
}

export const trendChartFailedBoxWrapper = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '60vh',
  textAlign: 'center',
  width: '60vw',
  height: '100%',
  mx: 'auto',
  px: 2,
  boxSizing: 'border-box',
  flex: 1,
}

export const trendChartSuccessBoxWrapper = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '60vh',
  textAlign: 'center',
  width: '100%',
  height: '100%',
  mx: 'auto',
  px: 2,
  boxSizing: 'border-box',
}

export const sideBarGridWrapper = {
  position: { xs: 'static', md: 'sticky' },
  top: 16,
  zIndex: 10,
  minWidth: 0,
  boxSizing: 'border-box',
  overflow: 'visible',
}

export const contentGridWrapper = {
  minWidth: 0,
  position: 'relative',
  zIndex: 1,
}

export const exportControlsBoxWrapper: SxProps<Theme> = {
  position: 'absolute',
  right: 20,
  top: 0,
  display: 'flex',
  gap: 1,
  p: 2,
  zIndex: 2,
}

export const exportControlsButton: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.primary.main,
  width: 40,
  height: 40,
  color: 'white',
}
